import React, { useState } from 'react';
import { LegalModal, LegalDocType } from './LegalModal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocType | null>(null);
  return <footer className="bg-cream border-t border-ink/5 pt-12 md:pt-20 pb-10" data-id="element-65">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center" data-id="element-66">
        <div className="font-serif text-2xl md:text-3xl tracking-wide text-ink mb-8 md:mb-12" data-id="element-67">
          El Cambio Hormonal
        </div>

        <div className="flex flex-wrap justify-center gap-5 md:gap-12 text-xs uppercase tracking-widest text-ink-light mb-8 md:mb-12" data-id="element-68">
          <button onClick={() => setOpenDoc('privacy')} className="hover:text-ink transition-colors" data-id="element-69">
            Política de Privacidad
          </button>
          <button onClick={() => setOpenDoc('terms')} className="hover:text-ink transition-colors" data-id="element-70">
            Términos de Servicio
          </button>
        </div>

        <p className="text-xs text-ink-light/50" data-id="element-71">
          © {new Date().getFullYear()} El Cambio Hormonal. Todos los derechos
          reservados.
        </p>
        <p className="text-sm text-ink-light/60 mt-4 max-w-2xl text-center italic font-serif" data-id="element-72">
          Creado con amor para acompañar a la mujer moderna en su camino hacia
          el balance natural.
        </p>
      </div>

      <LegalModal open={openDoc !== null} doc={openDoc ?? 'privacy'} onClose={() => setOpenDoc(null)} data-id="element-73" />
    </footer>;
}